export default __webpack_public_path__ + "static/about-9-508bf6508b94677130e382264691c13a.png";